import { Link } from "gatsby"
import React, { memo, useEffect, useRef, useState } from "react"
import { Container } from "react-bootstrap"
import "react-phone-input-2/lib/style.css"
import ErrorIcon from "../../assets/images/signup-error.svg"
import { serverRegions } from "../../constants/globalMessages"
import "../../styles/component/popup-signup.scss"
import SignupFormTest from "./sign-up-form-test"
import SVGIcon from "./SVGIcon"

function PopupSignup(props) {
  const [displayError, setDisplayError] = useState(false)
  const [errorText, setErrorText] = useState("")
  const ref = useRef()
  const [serverCountry, setServerCountry] = useState("US")
  const [countryPopup, setCountryPopup] = useState(false)
  const wrapperRef = useRef(null)

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setCountryPopup(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [wrapperRef])

  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id)

      if (!isScriptExist) {
        var script = document.createElement("script")
        script.type = "text/javascript"
        script.src = url
        script.id = id
        script.onload = function () {
          if (callback) callback()
        }
        document.body.appendChild(script)
      }

      if (isScriptExist && callback) callback()
    }

    loadScriptByURL(
      "recaptcha-key",
      `https://www.google.com/recaptcha/api.js?render=${process.env.CAPTCHA_KEY}`,
      function () {
        // console.log("Script loaded!")
      }
    )
  }, [])

  return (
    <div
      className='popup-signup-new dc-signup'
      style={{ display: !props.visibility && "none" }}
    >
      <div
        className='wrap position-fixed'
        onClick={() => ref.current.log() && props.togglePopup()}
        onKeyDown={() => ref.current.log() && props.togglePopup()}
        role='button'
        tabIndex={0}
      >
        {/*  */}
      </div>

      <div className='container-wrap position-fixed'>
        <div className='d-flex align-items-center justify-content-center h-100'>
          <Container className='position-relative popup-container'>
            <div className='overflow'>
              <div
                className='close position-absolute'
                onClick={props.togglePopup}
                onKeyDown={props.togglePopup}
                role='button'
                tabIndex={0}
              >
                <img
                  src='https://us-west-2.graphassets.com/AsRMKMrtKTFW6TGbr4KgUz/zpyoXoSXRuWnSQ1KauLF'
                  alt='close'
                  height='24'
                  width='24'
                />
              </div>

              <div className='forms'>
                <span
                  className='p16 info'
                  style={{
                    display: !displayError ? "block" : "none",
                  }}
                >
                  <center>
                    <p className='form-heading'>
                      {props.title
                        ? props.title
                        : "We'd love to have you on board. Enter your details, and we'll get in touch with you."}
                    </p>
                  </center>
                </span>
                <div
                  className='api-error p14'
                  style={{
                    display: displayError ? "block" : "none",
                  }}
                >
                  <img
                    src={ErrorIcon}
                    height='10'
                    width='10'
                    className='position-relative'
                    alt='img'
                  />
                  <p className='text-start'>{errorText}</p>
                </div>

                <SignupFormTest
                  ref={ref}
                  formAPI={props.formAPI}
                  setInputEmail={props.setInputEmail}
                  displayError={displayError}
                  setDisplayError={val => setDisplayError(val)}
                  errorText={errorText}
                  setErrorText={val => setErrorText(val)}
                  serverCountry={serverCountry}
                  setServerCountry={val => setServerCountry(val)}
                  disallowCommonDomains={props.disallowCommonDomains}
                  programName={props.programName}
                  signupEU
                />

                <span className='action p12 a12'>
                  <center>
                    <p className='data-loc mt16'>
                      Your data will be located in{serverCountry === "EU" ? "" : " the"}{" "}
                      <span
                        ref={wrapperRef}
                        className='fw-bold text-deep-purple position-relative country-name'
                        onClick={() => setCountryPopup(!countryPopup)}
                      >
                        <div
                          className={`position-absolute pop-up-location br-10 z-1 ${countryPopup ? "" : "dspnone"
                            }`}
                        >
                          {Object.values(serverRegions).map((item, id) => {
                            return (
                              <p
                                className={`text fw-bold p14 ${!serverRegions[serverCountry] &&
                                  item.code === "US"
                                  ? "text-pink"
                                  : item.code === serverCountry
                                    ? "text-pink"
                                    : ""
                                  }`}
                                onClick={() => setServerCountry(item.code)}
                              >
                                {item.country}
                              </p>
                            )
                          })}
                          <div className='position-relative'>
                            <SVGIcon
                              name='polygon'
                              className='polygon position-absolute'
                            />
                          </div>
                        </div>
                        {serverRegions[serverCountry]?.country ||
                          serverRegions["US"].country}
                      </span>
                    </p>
                    <p>
                      By clicking "
                      {props.ctaText ? props.ctaText : "GET STARTED FOR FREE"}",
                      you agree to SuperOps'{" "}
                      <Link to='/terms'>Terms of use</Link> and{" "}
                      <Link to='/privacy'>Privacy policy</Link>.
                    </p>
                  </center>
                </span>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </div>
  )
}

export default memo(PopupSignup)
